<template>
  <div>
    <el-tree
      ref="tree"
      class="classify-tree"
      :data="treeDataGather"
      :props="treeProps"
      :node-key="nodeKey"
      :highlight-current="true"
      :default-expanded-keys="expandedKeys"
      :expand-on-click-node="expandOnClickNode"
      :draggable="computed_draggable"
      :allow-drop="allowDrop"
      :allow-drag="allowDrag"
      :indent="indent"
      v-on="$listeners"
      @node-click="nodeClick"
      @node-drag-start="handleDragStart"
      @node-drag-enter="handleDragEnter"
      @node-drag-leave="handleDragLeave"
      @node-drag-over="handleDragOver"
      @node-drag-end="handleDragEnd"
      @node-drop="handleDrop"
    >
      <div slot-scope="{ node,data }" class="custom-tree-node" @mouseenter="handleMouseenter(data)" @mouseleave="handleMouseleave(data)">
        <template>
          <img v-if="customIcon" class="iconfont icon-wenjianjia-gongkai" src="~@/assets/img/wenjianjia.png" style="margin-right: 4px;">
          <span class="custom-tree-node-title" :title="node.label">{{ node.label }}</span>
          <span v-if="!customIcon">（{{ data.count || 0 }}）</span>
          <template>
            <el-tooltip effect="dark" content="新建子级" placement="right" :open-delay="1000">
              <el-popover
                v-show="(highlightNode === data.id || data.showTool) && editable"
                placement="right-start"
                width="244"
                v-model="node.addVisible"
                @show="handleShowAddPopover(node)"
                @after-leave="handleAfterLeaveAddPopover(node)">
                <el-form :ref="'ruleAddForm' + node.id" :model="node" :rules="rules">
                  <el-form-item prop="name">
                    <el-input v-model="node.name" :maxlength="30" placeholder="请输入子级名称"/>
                  </el-form-item>
                </el-form>
                <div style="text-align: right; margin: 10px 0 0 0">
                  <el-button size="mini" @click="handleCancelAdd(node)">取消</el-button>
                  <el-button type="primary" size="mini" @click="modifyName(node.name, node, data, 'add')">确定</el-button>
                </div>
                <el-button
                  v-if="TYPE === 'COMPONENT'"
                  type="text"
                  slot="reference"
                  :disabled="hasPermission(data.permissionType, permissionTable[TYPE].add)"
                  @click.stop="handleAdd(data, node)"
                  :style="{
                    color: highlightNode === data.id
                      ? (!hasPermission(data.permissionType, permissionTable[TYPE].add) ? 'currentColor' : '#ccc')
                      : null
                  }"
                >
                  <i :class="{'iconfont': true, 'icon-jiahao': true, 'custom-tree-node-add': true}"></i>
                </el-button>
              </el-popover>
            </el-tooltip>
            <el-popover
              popper-class="rename-popper"
              placement="right-start"
              width="244"
              v-model="node.renameVisible"
              @show="handleShowRenamePopover(node, data)"
              @click.native.stop>
              <el-form :ref="'ruleRenameForm' + node.id" :model="node" :rules="rules">
                <el-form-item prop="name">
                  <el-input v-model="node.name" :maxlength="30" placeholder="请输入子级名称"/>
                </el-form-item>
              </el-form>
              <div style="text-align: right; margin: 10px 0 0 0">
                <el-button size="mini" @click="handleCancelRename(node)">取消</el-button>
                <el-button type="primary" size="mini" @click="modifyName(node.name, node, data)">确定</el-button>
              </div>
            </el-popover>
            <el-popover
              v-show="(highlightNode === data.id || data.showTool) && editable"
              placement="bottom-start"
              width="80"
              popper-class="custom-tree-node-menu-popover"
              v-model="node.moreAction"
              :class="{'custom-tree-node-menu': !addNodeDisabled(node), 'custom-tree-node-menu-only': addNodeDisabled(node)}"
              @show="showPopover(data)"
            >
              <ul class="custom-tree-node-menu-content">
                <li class="node-item" @click="setPermission(data)">
                  <el-button type="text">权限</el-button>
                </li>
                <li slot="reference" class="node-item" v-show="data.parentId">
                  <el-button type="text" :disabled="hasPermission(data.permissionType, permissionTable[TYPE].rename)" @click.stop="handleRename(data, node)">重命名</el-button>
                </li>
                <li slot="reference" class="node-item" v-show="data.parentId" v-if="TYPE === 'FILE'">
                  <el-button type="text" :disabled="hasPermission(data.permissionType, permissionTable[TYPE].move)" @click.stop="handleMove(data, node)">移动</el-button>
                </li>
                <!-- <li @click="PermissionNode(node, data)">权限设置</li> -->
                <li @click="deleteNode(node, data)" v-show="data.parentId">
                  <el-button type="text" :disabled="hasPermission(data.permissionType, permissionTable[TYPE].delete)">删除</el-button>
                </li>
              </ul>
              <i slot="reference" class="iconfont icon-more" @click.stop="handleMoreAction(data, node)"/>
            </el-popover>
          </template>
        </template>
      </div>
    </el-tree>
    <gjw-dialog
      :show-dialog="showDialog"
      class="ClassifyPermissionDialog"
      :confirm-disable="confirmDisable"
      title="权限设置"
      :config="{'width': '770px'}"
      @close="closeDialog"
      @confirm="handleConfirm"
    >
      <permissionEdit v-if="showDialog" :node-data="activeNode.data" />
    </gjw-dialog>
    <edit-permission-dialog ref="editPermissionDialogRef" type="RESOURCE" :dialog-visible="editPermissionDialogVisible" :subTitle="permissionSubTitle" @close="editPermissionDialogVisible = false" @success="$emit('updateListData', 'permission')"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import permissionEdit from '@/components/business/resource/permissionEdit.vue'
import EditPermissionDialog from '@/components/business/EditPermissionDialog'
import permissionMixin from '@/mixins/permissionMixin.js'
export default {
  name: 'ClassifyTreeV2',
  mixins: [permissionMixin],
  components: { permissionEdit, EditPermissionDialog },
  props: {
    TYPE: {
      type: String,
      default: 'COMPONENT'
    },
    treeData: {
      /**
       * id
       * name
       * parentId
       * weight
       * children
       * ...
       *
       */
      type: Array,
      default: () => []
    },
    listData: {
      type: Array,
      default: () => []
    },
    editable: {
      type: Boolean,
      default: false,
    },
    expandedKeys: {
      type: Array,
      default: () => []
    },
    nodeKey: {
      type: String,
      default: 'id'
    },
    treeProps: {
      type: Object,
      default() {
        return {
          children: 'children',
          label: 'name'
        }
      }
    },
    expandOnClickNode: {
      type: Boolean,
      default: false
    },
    deep: {
      type: Number,
      default: 5
    },
    draggable: {
      type: Boolean,
      default: false
    },
    indent: {
      type: Number,
      default: 8.5
    },
    customIcon: {
      type: Boolean,
      default: false
    },
    currentSubmodule: {
      type: String
    }
  },
  data() {
    var validateSpecialChar = (rule, value, callback) => {
      if (!value) return
      if (value.includes('\\') || value.includes('/') || value.includes(':') || value.includes('*') ||
      value.includes('<') || value.includes('>') || value.includes('|') || value.includes('?')) {
        callback(new Error('不能包含特殊字符：\\ /:*<>|?'))
      } else {
        callback()
      }
    }
    return {
      treeDataGather: [],
      tempId: 10000,
      highlightNode: '',
      expandedKeysArr: [],
      editNodeNum: 0, // 只要有一个节点处于重命名或者新增状态，就不应该拖拽
      showDialog: false,
      confirmDisable: false,
      activeNode: null,
      rules: {
        name: [
          { required: true, message: '请输入子级名称', trigger: 'blur' },
          { validator: validateSpecialChar, trigger: 'change' },
          { validator: this.customValidate, trigger: 'blur' }
        ],
      },
      editPermissionDialogVisible: false,
      permissionSubTitle: '',
      ruleForm: {
        name: ''
      },
      spaceId: this.$route.params.spaceId,
      oldNode: null
    }
  },
  watch: {
    treeData(newVal) {
      this.treeDataGather = newVal
    }
  },
  computed: {
    ...mapGetters({
      spacesDetail: 'classifySpace/spacesDetail',
    }),
    computed_draggable() {
      return this.draggable && !this.editNodeNum
    },
    computed_expandedKeysArr() {
      return this.highlightNode ? [...[this.highlightNode], ...this.expandedKeys] : []
      // const highlightNodeArr = this.highlightNode ? [this.highlightNode] : []
      // // 处理expandedKeys存在[null]的情况

      // return [...new Set(this.expandedKeys.filter((item) => { return !!item }).concat(this.expandedKeysArr)), ...highlightNodeArr]
    },
    // 层级为deep的子节点不能进行添加子节点的操作
    addNodeDisabled() {
      return function(node) {
        if (node.data.deepId) {
          const nodeDeep = this.getNodeDeep(node)
          if (nodeDeep > this.deep - 1) {
            return true
          }
        }
        return false
      }
    },
    getCurrentSubmodule () {
      return this.currentSubmodule === 'V_Component_NOVA_DESIGN'
    },
    permissionTable() {
      return {
        COMPONENT: {
          add: this.getCurrentSubmodule ? 'NOVA_DESIGN_COMPONENT_CATEGORY_CREATE' : 'REVIT_COMPONENT_CATEGORY_CREATE',
          rename: this.getCurrentSubmodule ? 'NOVA_DESIGN_COMPONENT_CATEGORY_RENAME' : 'REVIT_COMPONENT_CATEGORY_RENAME',
          delete: this.getCurrentSubmodule ? 'NOVA_DESIGN_COMPONENT_CATEGORY_DELETE' : 'REVIT_COMPONENT_CATEGORY_DELETE'
        },
        FILE: {
          rename: 'FOLDER_RENAME',
          move: 'FILE_MOVE',
          delete: 'FOLDER_DELETE'
        }
      }
    }
  },
  created() {
    this.PreId = 'temp'
  },
  mounted() {
  },
  methods: {
    handleMouseenter(data) {
      this.$set(data, 'showTool', true)
    },
    handleMouseleave(data) {
      this.$set(data, 'showTool', false)
    },
    handleDragStart(node, ev) {
      // 节点开始拖拽时触发的事件
      // console.log('drag start', node)
    },
    handleDragEnter(draggingNode, dropNode, ev) {
      // 拖拽进入其他节点时触发的事件
      // console.log('tree drag enter: ', dropNode.label)
    },
    handleDragLeave(draggingNode, dropNode, ev) {
      // 拖拽离开某个节点时触发的事件
      // console.log('tree drag leave: ', dropNode.label)
    },
    handleDragOver(draggingNode, dropNode, ev) {
      // 在拖拽节点时触发的事件（类似浏览器的 mouseover 事件）
      // console.log('tree drag over: ', dropNode.label)
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      // 拖拽结束时（可能未成功）触发的事件
      console.log('tree drag end: ', dropNode && dropNode.label, dropType)
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      console.log('tree drop: ', dropNode.label, dropType)
      // 更新移动节点的deepId和parentId及其子节点的deepId
      let parentNode
      if (dropType === 'before') {
        parentNode = dropNode.parent
      } else if (dropType === 'inner') {
        parentNode = dropNode
      } else if (dropType === 'after') {
        parentNode = dropNode.parent
      }
      draggingNode.data.parentId = parentNode.data.id
      const preDeep = draggingNode.data.deepId.replace(draggingNode.data.id, '')
      const deepId = draggingNode.data.deepId
      this.listData.forEach((item) => {
        if (item.deepId.indexOf(deepId) > -1) {
          item.deepId = item.deepId.replace(preDeep, `${parentNode.data.deepId}_`)
        }
      })
      // 更新父节点下所有子节点的weight
      const children = parentNode.data.children || []
      children.forEach((item, index) => {
        item.weight = (index + 1) * 10
      })
      const arr = children.map((item) => {
        return {
          weight: item.weight,
          categoryId: item.id
        }
      })
      this.$api.resource.classify.moveSpacePlatClassify(parentNode.data.id, arr).then((res) => {
        if (res) {
          this.$emit('handleDrop')
        }
      }).catch((err) => {
        const errors = {
          'category.name.exist': '存在重名，请修改',
        }
        this.$matchError(err.code, errors, '添加目录失败')
      })
    },
    // 兄弟节点同名判断
    sameName(parentNode, node) {
      let sameName = false
      const children = parentNode.data.children || parentNode.data[0].children || []
      for (let i = 0; i < children.length; i++) {
        if (children[i].name === node.data.name && children[i].id !== node.data.id) {
          sameName = true
          break
        }
      }
      return sameName
    },
    allowDrop(draggingNode, dropNode, type) {
      // 拖拽时判定目标节点能否被放置
      // console.log('allowDrop', draggingNode, dropNode, type)
      let parentNode
      if (type === 'prev') {
        if (!dropNode.data.parentId) {
          // 不能和根目录同级
          return false
        }
        parentNode = dropNode.parent
      } else if (type === 'inner') {
        parentNode = dropNode
      } else if (type === 'next') {
        if (!dropNode.data.parentId) {
          // 不能和根目录同级
          return false
        }
        parentNode = dropNode.parent
      }
      // 同级节点存在同名的情况不能拖动
      const sameName = this.sameName(parentNode, draggingNode)
      if (sameName) {
        return false
      }
      const draggingNodeMaxDeep = this.getNodeMaxDeep(draggingNode)
      const draggingNodeDeep = this.getNodeDeep(draggingNode)
      const parentNodeDeep = this.getNodeDeep(parentNode)
      // 拖拽时不能超过最大层级限制
      return draggingNodeMaxDeep - draggingNodeDeep + 1 + parentNodeDeep <= this.deep
    },
    allowDrag(draggingNode) {
      // 判断节点能否被拖拽
      // 根节点不能拖拽
      return !!draggingNode.data.parentId
    },
    // 当前节点的深度
    getNodeDeep(node) {
      let deep
      const nodeDeepReg = node.data.deepId.match(/_/g)
      if (nodeDeepReg) {
        deep = nodeDeepReg.length + 1
      } else {
        deep = 1
      }
      return deep
    },
    // 当前节点的子节点的最大深度
    getNodeMaxDeep(node) {
      let maxDeep = 0
      this.listData.forEach((item) => {
        if (item.deepId.indexOf(node.data.deepId) > -1) {
          // 当前节点的子节点
          const deep = this.getNodeDeep({ data: item })
          if (maxDeep < deep) {
            maxDeep = deep
          }
        }
      })
      return maxDeep
    },
    // 设置某个选中值
    highlightSomeNode(nodeKey) {
      if (nodeKey) {
        this.$nextTick(() => {
          this.highlightNode = nodeKey
          this.$refs.tree.setCurrentKey(nodeKey)
        })
      }
    },
    handleAdd(data, node) {
      this.handleNodeClick(node)
    },
    handleMoreAction(data, node) {
      this.handleNodeClick(node)
    },
    handleRename(data, node) {
      this.handleNodeClick(node)
      node.renameVisible = true
      node.moreAction = false
    },
    handleMove(data, node) {
      this.$emit('handleMove', data)
    },
    handleNodeClick(node) {
      if (this.oldNode && this.oldNode !== node) {
        this.handleCancelAdd(this.oldNode)
        this.handleCancelRename(this.oldNode)
        this.$set(this.oldNode, 'moreAction', false)
      }
      // 更新上一次点击的节点
      this.oldNode = node
    },
    nodeClick(data) {
      const { name } = this.$route
      if (name === 'ComponentList') {
        this.permissionSubTitle = '目录名称：' + data.name
      }
      // this.currentKey = data[this.nodeKey]
      if (data.showMenu) {
        data.showMenu = false
        return false
      }
      this.$emit('tree-node-click', data)
    },
    async setPermission({ id, path, isFolder, name, suffix }) {
      if (this.TYPE === 'COMPONENT') {
        await this.$api.resource.hasResources(this.spaceId, id)
        this.permissionSubTitle = `目录名称：${name}`
        this.$refs.editPermissionDialogRef?.init({ id, path }, 'CATEGORY')
        this.editPermissionDialogVisible = true
      } else if (this.TYPE === 'FILE') {
        this.$emit('setPermission', { id, path, isFolder, name, suffix })
      }
    },
    handleCancelAdd(node) {
      node.addVisible = false
      this.activeApiCode = ''
      this.$refs[`ruleAddForm${node.id}`] && this.$refs[`ruleAddForm${node.id}`].clearValidate()
      this.$emit('startPolling')
    },
    handleCancelRename(node) {
      node.renameVisible = false
      node.name = ''
      this.activeApiCode = ''
      this.$refs[`ruleRenameForm${node.id}`] && this.$refs[`ruleRenameForm${node.id}`].clearValidate()
    },
    handleShowAddPopover(node) {
      this.$refs[`ruleAddForm${node.id}`] && this.$refs[`ruleAddForm${node.id}`].clearValidate()
      this.$emit('stopPolling')
    },
    handleAfterLeaveAddPopover(node) {
      !node.addVisible && this.$set(node, 'name', '')
      this.$emit('startPolling')
    },
    handleShowRenamePopover(node, data) {
      this.$set(node, 'name', data.name)
      this.$refs[`ruleRenameForm${node.id}`] && this.$refs[`ruleRenameForm${node.id}`].clearValidate()
      this.$emit('stopPolling')
    },
    modifyName(value, node, data, type) {
      this.$refs[type === 'add' ? `ruleAddForm${node.id}` : `ruleRenameForm${node.id}`].validate(async (valid) => {
        if (valid) {
          this.moreAction(value, node, data, type)
        } else {
          return false
        }
      })
    },
    async moreAction(value, node, data, type) {
      const oldName = data.name
      if (type === 'add' || data.id.toString().indexOf(this.PreId) > -1) {
        this.tempId++
        // 新增目录操作
        this.$api.resource.customCategories(this.spacesDetail.id, {
          name: value,
          parentId: data.id || data.parentId,
          weight: this.tempId
        }).then(() => {
          // 更新编辑状态下的节点的个数
          this.editNodeNum--
          data.addVisible = false
          this.ruleForm.name = ''
          this.activeApiCode = ''
          // 更新节点列表
          // this.listData.push(nodeData)
          this.$emit('handleNew')
        }).catch((err) => {
          if (err.code) {
            this.activeApiCode = err.code
            this.$refs[`ruleAddForm${node.id}`].validateField('name')
          }
          if (err.code === 'category.name.exist') {
            data.oldName = oldName
          }
        })
      } else {
        try {
          if (this.TYPE === 'COMPONENT') {
            await this.$api.resource.updateCustomCategories(this.spacesDetail.id, data.id, { name: value })
          } else if (this.TYPE === 'FILE') {
            await this.$api.file.renameFiles(this.spaceId, data.id, { name: value })
          }
          data.renameVisible = false
          data.moreAction = false
          // 更新编辑状态下的节点的个数
          this.editNodeNum--
          this.activeApiCode = ''
          this.$emit('handleRename')
        } catch (err) {
          if (err.code) {
            this.activeApiCode = err.code
            this.$refs[`ruleRenameForm${node.id}`].validateField('name')
          }
          if (err.code === 'category.name.exist') {
            data.oldName = oldName
          }
        }
      }
    },
    // 新建-重名校验
    customValidate(rule, value, callback) {
      const errors = {
        'category.name.exist': '存在重名，请修改',
        'space.type.not.support.edit': '该空间类型不支持编辑分类',
        'name.contain.special.characters': '名称包含特殊字符'
      }
      let errorFound = false
      for (const key in errors) {
        if (Object.prototype.hasOwnProperty.call(errors, key)) {
          if (this.activeApiCode === key) {
            this.activeApiCode = ''
            callback(new Error(errors[key]))
            errorFound = true
            break
          }
        }
      }
      if (!errorFound) {
        callback()
      }
    },
    cancelName(node, data) {
      if (data.id.toString().indexOf(this.PreId) > -1) {
        // 新增目录操作
        const parent = node.parent
        const children = parent.data.children
        const index = children.findIndex((d) => d.id === data.id)
        children.splice(index, 1)
      } else {
        // 取消目录重命名操作
        if (data.oldName) {
          data.name = data.oldName
          delete data.oldName
        }
      }
      // 更新编辑状态下的节点的个数
      this.editNodeNum--
    },
    async deleteNode(node, data) {
      if (this.TYPE === 'COMPONENT') {
        let tooltipText
        const hasResource = await this.$api.resource.hasResources(this.spaceId, data.id)
        if (hasResource) {
          tooltipText = '该层级或其子级下存在资源，是否将资源一起删除？'
        } else {
          tooltipText = `确定删除目录 <b>${data.name}</b>？`
        }
        this.$confirm(tooltipText, {
          type: 'warning',
          dangerouslyUseHTMLString: true,
          confirmButtonText: '删除',
          confirmButtonClass: 'confirm-delete'
        }).then(() => {
          this.$api.resource.deleteCustomCategories(this.spacesDetail.id, data.id).then(() => {
            const parent = node.parent
            const children = parent.data.children

            if (children) {
              const index = children.findIndex((d) => d.id === data.id)
              children.splice(index, 1)
            }
            // 更新节点列表
            // this.$emit('update:listData', this.listData.filter((item) => {
            //   return item.deepId.indexOf(data.deepId) > -1
            // }))
            this.$emit('updateListData', 'deleteNode')
          // this.$success('删除成功，删除当前分类及全部子分类')
          }).catch((err) => {
            const errors = {
              'resource.exist': '请将节点下的内容移除后再试。',
            }
            this.$matchError(err.code, errors, '删除目录失败')
          })
        }).catch(() => {})
      } else if (this.TYPE === 'FILE') {
        this.$emit('handleDelete', data, true)
      }
    },
    showPopover(data) {
      this.$set(data, 'showMenu', true)
    },
    PermissionNode(node, data) {
      this.activeNode = node
      this.showDialog = true
    },
    handleConfirm() {
      this.showDialog = false
    },
    closeDialog() {
      this.showDialog = false
    },
    setCheckedNodes(nodes) {
      this.$refs.tree && this.$refs.tree.setCheckedNodes(nodes)
    }
  }
}
</script>
<style lang='less' scoped>
.classify-tree {

  /deep/.el-tree-node__content {

    height: 32px;
    line-height: 32px;
    .custom-tree-node {
      width: calc(100% - 24px);
      display: flex;
      height: 32px;
      line-height: 32px;
      // position: relative;

      .custom-tree-node-title {
        // max-width: calc(100% - 103px);
        max-width: calc(100% - 84px);
        // margin-left: 3px;
        overflow: hidden;            // 溢出隐藏
        text-overflow: ellipsis;      // 溢出用省略号显示
        white-space: nowrap;         // 规定段落中的文本不进行换行
      }
      .icon-wenjianjia-gongkai {
        width: 20px;
        height: 20px;
        margin-top: 6px;
      }
      .custom-tree-node-menu-only {
        margin: 0 4px 0 auto;
      }
      .custom-tree-node-add {
        margin: 0 4px 0 auto;
      }
      .custom-tree-node-menu {
        margin-right: 4px;
      }
      .el-tooltip {
        margin-left: auto;
      }
    }
  }
}

.el-button--text {
  padding: 0;
  font-size: 14px;
  width: 100%;
  height: 100%;
}
</style>
<style lang="less">
.custom-tree-node-menu-popover {
  padding: 0px;
  min-width: 80px;

  .custom-tree-node-menu-content {
    padding: 4px 0;
    li {
      text-align: center;
      height: 26px;
      line-height: 26px;
      cursor: pointer;
      .el-button--text {
        color: @text-tag-gery;
        font-weight: normal;
      }
    }
    .node-item {
      &:hover {
        background: @bg-check-grey-light;
      }
    }
    >li:last-child {
      .el-button--text {
        color: @error-color;
      }
      &:hover {
        background: @error-color;
        .el-button--text {
          color: @color-fill-white;
        }
      }
    }
  }
}

.rename-popper {
  left: 325px !important;
}
.el-message-box .el-message-box__btns .confirm-delete {
  color: @color-text-grey-0 !important;
  background: @error-color !important;
  border-color: @error-color !important;
}
</style>
